module.exports = __webpack_public_path__ + "img/white-cross.ae319793.webp";